import './jquery/jquery.countdown.min.js';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/slider';
import 'jquery-ui-slider/jquery-ui.structure.min.css';
import './jquery/jquery.ui.touch-punch.min.js';
import './jquery/jquery.magnific-popup.min.js';
import 'magnific-popup/dist/magnific-popup.css';
import 'normalize.css/normalize.css';
import {Swiper, Thumbs, Navigation, EffectFade, Pagination} from 'swiper/dist/js/swiper.esm';
import 'swiper/dist/css/swiper.min.css';
import Cookies from 'js-cookie/src/js.cookie.js';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import 'waypoints/lib/jquery.waypoints.min'
import 'intersection-observer'
import PinchZoom from 'pinch-zoom-js'
import inputmask from 'inputmask';
import intlTelInput from 'intl-tel-input';
import './jquery/jquery.cookie';

Swiper.use(Thumbs);
Swiper.use(Navigation);
Swiper.use(EffectFade);
Swiper.use(Pagination);

window.Swiper = Swiper;
window.Cookies = Cookies;
window.PerfectScrollbar = PerfectScrollbar;
window.InputMask = inputmask;
window.intlTelInput = intlTelInput;
window.PhoneInputMask = new window.InputMask(document.domain.split(".")[1]==="by" ? "+375 (99) 999-99-99" : "+7 (999) 999-99-99");
window.PinchZoom = PinchZoom;
